var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M32.5 20.5V23.5L12.5 23.5L12.5 20.5L32.5 20.5Z","fill":"black","key":1})]);
}

Minus.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
